import { __generator } from "tslib";
import { put, select, call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { withOffset } from '../../Stream';
import { getCurrentStreamId, getCurrentMediaSource, getCurrentGallection, getCurrentSubfolder, getCurrentStreamItems, getCurrentTier, } from '../selectors';
import { getGallectionType } from '../helpers';
import { MediaSourceType } from '../types';
import updateGallectionSize from './updateGallectionSize';
import setGallectionCover from './setGallectionCover';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
function addDeviationsHandler(action) {
    var _a, streamId, mediaSource, currentTier, currentGallection, currentSubfolder, currentDeviationIds, deviations, _b, ids, entities, type, targetGallection, deviationids, data, tierId, deviationIds;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    streamId: getCurrentStreamId(state),
                    mediaSource: getCurrentMediaSource(state),
                    currentTier: getCurrentTier(state),
                    currentGallection: getCurrentGallection(state),
                    currentSubfolder: getCurrentSubfolder(state),
                    currentDeviationIds: getCurrentStreamItems(state),
                }); })];
            case 1:
                _a = _c.sent(), streamId = _a.streamId, mediaSource = _a.mediaSource, currentTier = _a.currentTier, currentGallection = _a.currentGallection, currentSubfolder = _a.currentSubfolder, currentDeviationIds = _a.currentDeviationIds;
                deviations = action.payload.filter(function (d) { return !currentDeviationIds.includes(d.deviationId); });
                if (!streamId || deviations.length < 1) {
                    return [2 /*return*/];
                }
                _b = normalizeDeviations(deviations), ids = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(withOffset.actions.insertItems({
                        streamId: streamId,
                        items: ids,
                        entities: entities,
                        offset: 0,
                    }))];
            case 2:
                _c.sent();
                // If this is a non-gallection like those used in journal galleries, we only
                // need to change the stream. Everything after this saves changes on the server
                if (mediaSource === MediaSourceType.CUSTOM_SET) {
                    return [2 /*return*/];
                }
                type = getGallectionType(mediaSource);
                if (!(currentGallection && type && type !== 'stash')) return [3 /*break*/, 6];
                targetGallection = currentSubfolder || currentGallection;
                return [4 /*yield*/, call(updateGallectionSize, targetGallection.folderId, deviations.length)];
            case 3:
                _c.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: targetGallection,
                        deviation: deviations[0],
                        onlyIfMissing: true,
                    })];
            case 4:
                _c.sent();
                deviationids = deviations.map(function (deviation) { return deviation.deviationId; });
                data = {
                    type: type,
                    target_folderid: targetGallection.folderId,
                    deviationids: deviationids,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: data,
                    })];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6:
                if (!currentTier) return [3 /*break*/, 8];
                tierId = currentTier.deviationId;
                deviationIds = deviations.map(function (deviation) { return deviation.deviationId; });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'tier/deviation/add',
                        data: {
                            tier_deviationid: tierId,
                            deviationids: deviationIds,
                        },
                    })];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
export default addDeviationsHandler;
//# sourceMappingURL=addDeviations.js.map